<template>
    <div>
        <div class="flashsale">
            <div class="wrapper-flashsale">
                <div class="flashsale-logo">
                    <img src="../../../../assets/new/icon/ic-flash-sale@3x.png"/>
                </div>
                <div class="flashsale-time d-flex">
                    <div class="time-label">{{ lbl.home.flashsale_end }}</div>
                    <div class="time-block">{{getTimerSplit().day}}</div>
                    <div class="time-item">:</div>
                    <div class="time-block">{{getTimerSplit().hour}}</div>
                    <div class="time-item">:</div>
                    <div class="time-block">{{getTimerSplit().minute}}</div>
                    <div class="time-item">:</div>
                    <div class="time-block">{{getTimerSplit().second}}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import TimerHelper from "@/helper/TimerHelper.js";
import DatetimeHelper from "@/helper/DatetimeHelper.js";
import FlashSaleHelper from "@/helper/FlashSaleHelper";
import LocaleMixin from "@/mixin/LocaleMixin";

export default {
    name: 'FlashSaleBar',
    mixins: [LocaleMixin],
    props: {
        campaign: Array
    },
    data: function () {
        return {
            timer: new TimerHelper(),
        }
    },
    created: function() {
        this.campaigns = this.campaign
        this.setFlashSaleTime()
    },
    methods: {
        setFlashSaleTime: function () {
            if (this.campaigns != null) {
                let campaign = this.campaigns[0];
                let current = DatetimeHelper.getCurrentTimeTimezoneThai();
                let expDate = campaign.expireDate;
                if (current < expDate) {
                    this.isShowFlashSale = true;
                    this.runTimer(campaign);
                } else {
                    this.isShowFlashSale = false;
                }
            } else {
                return ;
            }
        },
        runTimer: function(campaign) {
            let current = DatetimeHelper.getCurrentTimeTimezoneThai();
            let expDate = campaign.expireDate;
            let expireIn = expDate - current;

            this.timer.initialTimer(expireIn, ' : ', true, true,true);
            this.timer.runTimer(() => {
                this.isShowFlashSale = false;
                this.flashsaleExpire();
            });
        },
        flashsaleExpire: function() {
            this.modalController.alertModal
                                .clearModal()
                                .setMsg(this.lbl.bzbdealshop.flashsale.expire)
                                .setBlobConfig(this.blobConfig)
                                .setBtnOk(this.lbl.bzbdealshop.flashsale.close)
                                .show();
            this.modalController.alertModal.onClickOk(()=>{
                this.$router.push('/')
            });
        },
        getTimerSplit: function() {
            return FlashSaleHelper.getTimerSplit(this.timer);
        }
    }
}
</script>

<style lang="scss" scoped>
@import '../../../../style/base/base.scss';
    .flashsale {
        .wrapper-flashsale {
            display: flex;
            justify-content: space-between;
            .flashsale-logo {
                img {
                    width: 252px;
                }
            }
            .flashsale-time {
                background-image: url('../../../../assets/new/bg/bg-timer@3x.png');
                background-size: 100% 100%;
                background-repeat: no-repeat;
                padding: 0 10px 0 26px;
                .time-label {
                    width: 100%;
                    font-size: $px16;
                    margin: auto 0px auto auto;
                    padding: 0 10px;
                    color: #000;
                }
                .time-block {
                    width: auto;
                    height: 25px;
                    min-width: 40px;
                    font-size: $px16;
                    text-align: center;
                    padding: 0 4px 0;
                    border-radius: 5px;
                    background-color:#000;
                    margin: auto 5px;
                    color: #fff;
                }
            }
            .time-item {
                padding: 0 5px;
                margin: auto 0;
            }
        }
    }
</style>
